import { render } from "./salers.vue?vue&type=template&id=0c33a54c"
import script from "./salers.vue?vue&type=script&lang=js"
export * from "./salers.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\TEHNOLAND\\megamarketAdmin\\adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__